import React from 'react';

import Grid from '@material-ui/core/Grid';

import { BarChart, Bar, Tooltip, XAxis, YAxis, ReferenceLine } from 'recharts';

class BarChartComponentAlternative extends React.Component {

    render() {
        let getValue = (x) => {
            if (x.length === 0) {
                return x.Value
            }
            else {
                return parseFloat(x.Value)
            }
        }

        return (
            <Grid container direction="row"
                justifyContent="center" alignItems="center">
                <BarChart width={950} height={500} data={this.props.data}>
                    <XAxis angle={-5} dataKey="Time" />
                    <YAxis dataKey={getValue}
                        domain={['dataMin', 'dataMax']} />
                    <Tooltip />
                    <Bar dataKey="Value" fill="#8884d8" />

                    <ReferenceLine y={this.props.trigger_level[0]['value_1']}
                        label={this.props.trigger_level[0]['value_1_name']}
                        stroke="green" />
                    <ReferenceLine y={this.props.trigger_level[1]['value_2']}
                        label={this.props.trigger_level[1]['value_2_name']}
                        stroke="orange" />
                    <ReferenceLine y={this.props.trigger_level[2]['value_3']}
                        label={this.props.trigger_level[2]['value_3_name']}
                        stroke="red" />
                </BarChart>
            </Grid>
        )
    }
}

export default BarChartComponentAlternative;